import { getBackendData } from "./xhrbackend";
import { DomHelper } from "./domHelper";
import { DEBUG, DEFAULT_PREFS } from "./config";
import { getAppCardNode } from "./appCardDefault";
function renderGrades4Class(response, schoolid, id, bearerToken) {
    const jsonData = JSON.parse(response);
    console.log("renderGrades4Class");
    const schoolGrid = document.getElementById('odSchoolGrid');
    if (schoolGrid) {
        const tableGrade = schoolGrid.querySelector('table.od-grade');
        if (tableGrade) {
            tableGrade.remove();
        }
    }
    const schoolClass = jsonData.classes[0];
    const lessons = schoolClass.lessons;
    const allGrades = [];
    lessons.forEach((lesson) => {
        allGrades.push(...lesson.grades);
    });
    const headings = [];
    allGrades.forEach((grade) => {
        const heading = {
            gradeArea: grade.gradeArea.name,
            gradeType: grade.gradeType.name,
        };
        if (!headings.some((h) => h.gradeArea === heading.gradeArea && h.gradeType === heading.gradeType)) {
            headings.push(heading);
        }
    });
    const pupilGradesMap = {};
    allGrades.forEach((grade) => {
        const pupil = grade.pupil.fullName;
        const headingKey = `${grade.gradeArea.name} - ${grade.gradeType.name}`;
        if (!pupilGradesMap[pupil]) {
            pupilGradesMap[pupil] = {};
        }
        pupilGradesMap[pupil][headingKey] = grade.gradeValue;
    });
    const sortedPupils = Object.keys(pupilGradesMap).sort((a, b) => a.localeCompare(b));
    const table = DomHelper.appendNode(schoolGrid, 'table', ['od-grade']);
    const thead = DomHelper.appendNode(table, 'thead', []);
    const headerRow = DomHelper.appendNode(thead, 'tr', []);
    DomHelper.appendNode(headerRow, 'th', [], [], 'Lernende');
    headings.forEach((heading) => {
        DomHelper.appendNode(headerRow, 'th', [], [], `${heading.gradeArea} - ${heading.gradeType}`);
    });
    const tbody = DomHelper.appendNode(table, 'tbody', []);
    sortedPupils.forEach((pupil) => {
        const gradeMap = pupilGradesMap[pupil];
        const row = DomHelper.appendNode(tbody, 'tr', []);
        DomHelper.appendNode(row, 'th', [], [], pupil);
        headings.forEach((heading) => {
            var _a;
            const gradeKey = `${heading.gradeArea} - ${heading.gradeType}`;
            DomHelper.appendNode(row, 'td', [], [], ((_a = gradeMap[gradeKey]) === null || _a === void 0 ? void 0 : _a.toString()) || '-');
        });
    });
}
function renderComputedGrades4Class(response, schoolid, id, bearerToken) {
    const jsonData = JSON.parse(response);
    console.log("renderComputedGrades4Class");
    const schoolGrid = document.getElementById('odSchoolGrid');
    if (schoolGrid) {
        const tableGrade = schoolGrid.querySelector('table.od-grade');
        if (tableGrade) {
            tableGrade.remove();
        }
    }
    const schoolClass = jsonData.classes[0];
    const lessons = schoolClass.lessons;
    const allGrades = [];
    lessons.forEach((lesson) => {
        allGrades.push(...lesson.gradesCalculated);
    });
    const headings = [];
    lessons.forEach((lesson) => {
        const heading = {
            lesson: lesson.shortName
        };
        if (!headings.some((h) => h.lesson === heading.lesson)) {
            headings.push(heading);
        }
    });
    const pupilGradesMap = {};
    allGrades.forEach((grade) => {
        const pupil = grade.pupil.fullName;
        const headingKey = `${grade.lesson.shortName}`;
        if (!pupilGradesMap[pupil]) {
            pupilGradesMap[pupil] = {};
        }
        pupilGradesMap[pupil][headingKey] = grade.gradeValue;
    });
    const sortedPupils = Object.keys(pupilGradesMap).sort((a, b) => a.localeCompare(b));
    const table = DomHelper.appendNode(schoolGrid, 'table', ['od-grade']);
    const thead = DomHelper.appendNode(table, 'thead', []);
    const headerRow = DomHelper.appendNode(thead, 'tr', []);
    DomHelper.appendNode(headerRow, 'th', [], [], 'Lernende');
    headings.forEach((heading) => {
        DomHelper.appendNode(headerRow, 'th', [], [], `${heading.lesson}`);
    });
    const tbody = DomHelper.appendNode(table, 'tbody', []);
    sortedPupils.forEach((pupil) => {
        const gradeMap = pupilGradesMap[pupil];
        const row = DomHelper.appendNode(tbody, 'tr', []);
        DomHelper.appendNode(row, 'th', [], [], pupil);
        headings.forEach((heading) => {
            var _a;
            const gradeKey = `${heading.lesson}`;
            DomHelper.appendNode(row, 'td', [], [], ((_a = gradeMap[gradeKey]) === null || _a === void 0 ? void 0 : _a.toString()) || '-');
        });
    });
}
export function handleGradeShow(schoolid, classItem, bearerToken, event) {
    getBackendData('', `/school/${schoolid}/class/${classItem.id}/grades`, 'GET', 'application/json', bearerToken, function (result) {
        renderComputedGrades4Class(result.target.response, schoolid, classItem.id, bearerToken);
    });
}
export function appDeskPupilGrades(username, bearerToken, parentNode, app, userResponse) {
    if (DEBUG)
        console.log("-->appDeskPupilGrades");
    const additionalClassList = [];
    const idString = 'rudi-school-grades';
    if (!userResponse.odDeskPreferences)
        userResponse.odDeskPreferences = DEFAULT_PREFS;
    let content = "";
    const cardNode = getAppCardNode(parentNode, app, username, userResponse.odDeskPreferences, bearerToken, false, additionalClassList, null, (event) => {
        if (cardNode) {
            if (cardNode.classList.contains("app-open")) {
                cardNode.classList.remove('rudi-col-span-2');
                cardNode.classList.remove('app-open');
                cardNode.classList.add('rudi-max-height');
                DomHelper.removeCloseSection(cardNode);
            }
            else {
                cardNode.classList.add('app-open');
                cardNode.classList.add('rudi-col-span-2');
                cardNode.classList.remove('rudi-max-height');
                DomHelper.appendCloseSection(cardNode, (event) => {
                    cardNode.classList.remove('app-open');
                    cardNode.classList.remove('rudi-col-span-2');
                    cardNode.classList.add('rudi-max-height');
                });
            }
        }
    });
}
